import { ReactNode } from "react";
import { motion } from "framer-motion";

export interface MarketingSectionProps {
  id?: string;
  children: ReactNode;
  className?: string;
  maxWidth?: "3xl" | "4xl" | "5xl" | "6xl";
  background?: "default" | "muted" | "none";
  withBorder?: boolean;
}

export default function MarketingSection({
  id,
  children,
  className = "",
  maxWidth = "5xl",
  background = "default",
  withBorder = false,
}: MarketingSectionProps) {
  const maxWidthClasses = {
    "3xl": "max-w-3xl",
    "4xl": "max-w-4xl",
    "5xl": "max-w-5xl",
    "6xl": "max-w-6xl",
  };

  const backgroundClasses = {
    default: "",
    muted: "bg-slate-900/30",
    none: "",
  };

  const borderClasses = withBorder ? "border-y border-slate-800" : "";

  return (
    <section
      id={id}
      className={`py-16 px-6 scroll-mt-24 ${backgroundClasses[background]} ${borderClasses} ${className}`}
    >
      <div className={`container mx-auto ${maxWidthClasses[maxWidth]}`}>
        {children}
      </div>
    </section>
  );
}

export interface MarketingSectionHeaderProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
}

export function MarketingSectionHeader({
  title,
  subtitle,
  centered = true,
}: MarketingSectionHeaderProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className={`mb-12 ${centered ? "text-center" : ""}`}
    >
      <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
        {title}
      </h2>
      {subtitle && (
        <p className="text-muted-foreground max-w-2xl mx-auto">
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}
